import { ICalendarDisplaySettingsModel } from "@/Appointments/Models/UI/ICalendarDisplaySettingsModel";

class CalendarDisplay {
    public IsAllSitesChecked: boolean;
    public IsAllEmployeesChecked: boolean;
    public IsAllRoomsChecked: boolean;
    public IsAllEquipmentChecked: boolean;
    public EmployeeIds: string[];
    public RoomIds: string[];
    public SiteIds: string[];
    public ShowOnlySelectedSite: boolean;
    public SortByScheduleSelectedEmployees: boolean;
    public PatientsAreVisible: boolean;
    public StatusAreVisible: boolean;
    public RoomsAreVisible: boolean;
    public ContactPointsAreVisible: boolean;
    public IncludeCanceled: boolean;
    public IncludeNAM: boolean;
    public TimeSlotLength: number;
    public OneLineViewSelected: boolean;
    // Added a Bool to the user setting if the user want to show Service name on service duration <5
    public Service5minAreVisible: boolean;
    public SiteAreVisible: boolean;
    public AreRulesetsCollapsed: boolean;
    public CalendarTimeResolutions: number[];
    public MaximumCalendarsShown: {
        Day: number,
        Week: number,
        Month: number,
    };
    public CanadianTriageAndAcuityScoreVisible: boolean;

    public static FromModel(model: ICalendarDisplaySettingsModel): CalendarDisplay {
        const helper = cacheStore.Helper;
        const display = new CalendarDisplay();

        display.IsAllSitesChecked = model.get("IsAllSitesChecked");
        display.IsAllEmployeesChecked = model.get("IsAllEmployeesChecked");
        display.IsAllRoomsChecked = model.get("IsAllRoomsChecked");
        display.IsAllEquipmentChecked = model.get("IsAllEquipmentChecked");
        display.EmployeeIds = helper.GetCheckedItemsFromICheckableList(model.get("EmployeesGlobalCache")).map(x => x.AlternativeId).toArray();
        display.RoomIds = helper.GetCheckedItemsFromICheckableList(model.get("RoomsFiltered")).map(x => x.Id).toArray();
        display.SiteIds = helper.GetCheckedItemsFromICheckableList(model.get("Sites")).map(x => x.Id).toArray();
        display.ShowOnlySelectedSite = model.get("ShowOnlySelectedSites");
        display.SortByScheduleSelectedEmployees = model.get("SortByScheduleSelectedEmployees");
        display.PatientsAreVisible = model.get("PatientsAreVisible");
        display.StatusAreVisible = model.get("StatusAreVisible");
        display.RoomsAreVisible = model.get("RoomsAreVisible");
        display.ContactPointsAreVisible = model.get("ContactPointsAreVisible");
        display.IncludeCanceled = model.get("IncludeCanceled");
        display.IncludeNAM = model.get("IncludeNAM");
        display.TimeSlotLength = model.get("TimeSlotLength");
        display.Service5minAreVisible = model.get("Service5minAreVisible");
        display.SiteAreVisible = model.get("SitesAreVisible");
        display.AreRulesetsCollapsed = model.get("AreRulesetsCollapsed");
        display.OneLineViewSelected = model.get("OneLineViewSelected");
        display.MaximumCalendarsShown = {
            Day: model.get("MaximumCalendarsShownForDay"),
            Week: model.get("MaximumCalendarsShownForWeek"),
            Month: model.get("MaximumCalendarsShownForMonth")
        };
        display.CanadianTriageAndAcuityScoreVisible = model.get("CanadianTriageAndAcuityScoreVisible");

        return display;
    }
}

export { CalendarDisplay };
